export default __webpack_public_path__ + "static/android-icon-192x192-d354c87df43806ea8da79410d307ec9d.png";